import React from "react";
import { Link } from "react-router-dom"; // <- import Link
import "./Footer.css";

function Footer() {
  return (
    <div className="FWrapper">
      <div className="footer-section">
        <h3>Quality</h3>
        <p>
          Premium aluminium windows, doors, and gates for South African homes
          and businesses. Quality craftsmanship since 2010.
        </p>
      </div>

      <div className="footer-section">
        <h3>Quick Links</h3>
        <ul>
          <li>
            <Link to="/">Home</Link>
          </li>
          <li>
            <Link to="/Contact">About Us</Link>
          </li>
          <li>
            <Link to="/Products">Products</Link>
          </li>
          <li>
            <Link to="/Services">Services</Link>
          </li>
          <li>
            <Link to="/projects">Projects</Link>
          </li>
        </ul>
      </div>

      <div className="footer-section">
        <h3>Products</h3>
        <ul>
          <li>
            <Link to="/Products?filter=Sliding">Sliding</Link>
          </li>
          <li>
            <Link to="/Products?filter=Doors">Doors</Link>
          </li>
          <li>
            <Link to="/Products?filter=Windows">Windows</Link>
          </li>
          <li>
            <Link to="/Products?filter=Garage">Garage Doors</Link>
          </li>
          <li>
            <Link to="/Products">Custom Solutions</Link>
          </li>
        </ul>
      </div>

      <div className="footer-section contact-info">
        <h3>Contacts</h3>
        <p>
          <span className="material-symbols-outlined">phone_in_talk</span>
          065 554 7428
        </p>
         <p>
          <span className="material-symbols-outlined">mail</span>
          ipfieisrael@gmail.com
        </p>
      </div>

      <div className="footer-section business-hours">
        <h3>Working Hours</h3>
        <p>Mon-Fri: 8:00 AM - 5:00 PM</p>
        <p>Sat: 8:00 AM - 1:00 PM</p>
        <p>Sun: Closed</p>
      </div>
    </div>
  );
}

export default Footer;